import { resolveUrl } from "~/utils/url/urlResolver";
import { getCsrfValue } from "~/common/utils/ApiHelper";

const url = resolveUrl("/cad/partNumberAvailability");

export async function fetchPartNumberAvailability(partNumber: string) {
  const response = await fetch(url, {
    body: JSON.stringify({ partNumber }),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });

  return response.json();
}
